<template>
  <div class="dg__listItem" :class="{ inline: _inline }" :style="itemStyle">
    <div class="lable" :style="labelStyle" :class="[labelClass, list.labelClass]"> <span v-if="required"
        class="t-[#FF4D4F]">*</span> {{ label || "" }}{{ label ? list.labelSuffix : "" }}</div>
    <div class="value">
      <slot></slot>
    </div>
  </div>
</template>

<script>
// import { defineComponent, computed, inject } from "vue";
// import type { CSSProperties } from "vue";

export default {
  name: "dg-list-item",
  props: {
    labelWidth: {
      type: String,
      default: ""
    },
    labelClass: {
      type: String,
      default: ""
    },

    inlineWidth: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    required: Boolean,
    margin: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  computed: {
    list() {
      return this.$parent;
    },
    _inline() {
      return this.$parent.inline;
    },
    labelStyle() {
      let p = this.list;
      const ret = {};
      const labelWidth = this.labelWidth || p.labelWidth;
      const color = this.color || p.color;
      const size = this.size || p.size;


      if (labelWidth) {
        if (labelWidth.indexOf('px') > -1 || !isNaN(labelWidth)) {
          ret.flexBasis = labelWidth + "px";
        } else if (labelWidth.indexOf('%') > -1) {
          ret.flexBasis = labelWidth + "%";
        }
      }

      if (color) {
        ret.color = color;
      }
      if (size) {
        ret.fontSize = size;
      }
      return ret;
    },
    itemStyle() {
      let p = this.list;
      const ret = {};
      const inlineWidth = this.inlineWidth || p.inlineWidth;
      const margin = p.margin;
      if (margin && margin.length) {
        ret.margin = margin
          .map(el => {
            return `${el}px`;
          })
          .join(" ");
      }

      if (p.inline && inlineWidth) {

        if (inlineWidth) {
          if (inlineWidth.indexOf('px') > -1 || !isNaN(inlineWidth)) {
            ret.width = parseInt(inlineWidth) + "px";
          } else if (inlineWidth.indexOf('%') > -1) {
            ret.width = parseInt(inlineWidth) + "%";
          }
        }
      }




      return ret;
    }
  }
};
</script>

<style scoped>
.dg__listItem {
  display: flex;
  padding-top: 4px;
  padding-bottom: 4px;
}

.dg__listItem.inline {
  display: inline-flex;
  min-width: 250px;
}

.dg__listItem .value {
  flex: 1;
  overflow: hidden;
  text-align: left;
  padding-left: 5px;
  font-size: 14px;
  word-wrap: break-word;
  word-break: normal;
  color: #303133;
}

.dg__listItem .lable {
  flex-basis: 80px;
  font-size: 14px;
  color: #909399;
}
</style>
 <style>.t-\[\#FF4D4F\] {
    color: #FF4D4F
}
.inline {
    display: inline
}</style>